// extracted by mini-css-extract-plugin
export default {"keyValueListContainer":"u9y5TH"};